import { Component } from '@angular/core';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { DriverRecordRequestService } from 'src/app/services/driverrecordrequest.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-start',
    templateUrl: './start.component.html',
    styleUrls: ['./start.component.scss'],
    standalone: false
})
export class StartComponent {

     public wizard!: IWizard;

     constructor(public service: DriverRecordRequestService, private route: ActivatedRoute) {
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);

          this.service.new();

          this.route.url.subscribe(url => {
               if (url.find(x => (x.path === "subscribe"))){
                    this.service.justSubscribe = true;
               }
               this.wizard = this.service.getWizard();
          });
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
